import { render, staticRenderFns } from "./PVSystem.vue?vue&type=template&id=8a70502a&scoped=true&"
import script from "./PVSystem.vue?vue&type=script&lang=ts&"
export * from "./PVSystem.vue?vue&type=script&lang=ts&"
import style0 from "./PVSystem.vue?vue&type=style&index=0&id=8a70502a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a70502a",
  null
  
)

export default component.exports